import Colors from "../../../config/colors";
import { constructIds, getConstructLabel, getConstructType } from "../../../config/common";
import { generateMongoId, collectChildren, generatePrefix } from "../../../utils/commonUtils";
import { invokePostService, invokeGetService, handleSnackBar, setReRender } from "../../../store/global/actions";
import { getIconPath } from "../../../config";
import { doesConnectionExist, enableHorizontalAutoScrollOnDrag, generateClusterletsWithUpdatedOrder, generateName, getNearbyNodeOnDrag, hideAllOtherElementsOnNodeDragging, renderNodeLabelWithWrapper, updateElementYPosition, updateNodeLabelXPosition, updateNodeVerticalLineXPosition, updateVerticalLineHeight } from "../../../utils/raphaelHelpers";

export class NodeManager {
  constructor({diagramManager, paper, dispatch, selectedTransaction, events, clusterlets, transactions, handleSelectedItem, defaultNodeVerticalLineHeight, checkCodeEditorStatus}) {
    this.diagramManager = diagramManager;
    this.paper = paper;
    this.dispatch = dispatch;
    this.selectedTransaction = selectedTransaction;
    this.transactions = transactions;
    this.events = events;
    this.clusterlets = clusterlets;
    this.nodes = {};
    this.level = 0; // Global vertical level based on arrows
    this.plusOffsetY = 40; // Initial vertical offset for + icons
    this.plusShiftStep = 30; // Vertical step per arrow
    this.baseLineY = 140; // Base line start Y (node bottom)
    this.popupIconSize = 22;  //Icon size for the event/nested transaction drawing tool 
    this.plusIconSize = 22; 
    this.popupIconOffset = 22;
    this.nodelabelFontSize = 14;
    this.nodeTypeFontSize = 10;
    this.newDrawnElements = [];
    this.newNodePositions = {};
    this.handleSelectedItem = handleSelectedItem;
    this.defaultNodeVerticalLineHeight = defaultNodeVerticalLineHeight;
    this.globalPopUpSet = null;
    this.popupSetElements = {};
    this.popupBufferRect = {};
    this.popUpVisibility = {right : false, left : false, bottom : false, plus:false};
    this.lastDrawnElement = null;
    this.checkCodeEditorStatus = checkCodeEditorStatus;
  }

  // Configs
  icons = {
    plusiconNormalPath : `${process.env.PUBLIC_URL}/ide_icons/plus_icon_white.png`,
    plusiconHoveredPath : `${process.env.PUBLIC_URL}/ide_icons/plus_icon_yellow.png`,
    rightEventIconPath : `${process.env.PUBLIC_URL}/ide_icons/right.png`,
    leftEventIconPath : `${process.env.PUBLIC_URL}/ide_icons/left.png`,
    childTransactionIconPath : `${process.env.PUBLIC_URL}/ide_icons/hexagon.png`,
    delegateIconPath : `${process.env.PUBLIC_URL}/delegate_icons/ide_delegate_inner_default.svg`,
    dragHandle : `${process.env.PUBLIC_URL}/ide_icons/event_drag_handler.svg`,
  }
  dragHandlerConfig = {
    width : 20,
    height : 24,
  }
  nodeWrapperRectConfig = {
    width: 60,
    height: 50,
     
  }

  nodeShapeConfig = {
    mouseOverFill: "#fcfc69"
  }

  updateTransactionData(data){
    const {selectedTransaction, events, clusterlets, connections, transactionEvents,  transactions} = data;
    if(selectedTransaction) this.selectedTransaction = selectedTransaction;
    if(events) this.events = events;
    if(clusterlets) this.clusterlets = clusterlets;
    if(transactions) this.transactions = transactions;
    if(connections) this.connections = connections;
    if(transactionEvents) this.transactionEvents = transactionEvents;
  }

  setArrowManager(arrowManager) {
    this.arrowManager = arrowManager;
  }


  renderNode(id, x, y, label, icon = "●", type, node, options = {}) {
    const nodeData = this.clusterlets.find(c => c._id === id) || {};
    const group = this.paper.set();
    const plusCircleGroup = this.paper.set();

    const { nodelabelFontSize = 14, nodeTypeFontSize = 10 } = options;
    let imgSrc = ""
 
    if(node.type === 1){
      imgSrc = `${process.env.PUBLIC_URL}${this.getClusterletIconPath(node, {fileUrl : getIconPath(), iconPath : 'delegate_icons', defaultIcon : 'ide_delegate_inner_default'})}`
    }
    else{
      imgSrc = `${process.env.PUBLIC_URL}${this.getClusterletIconPath(node, {fileUrl : getIconPath(),})}`
    }

    const {nodeLabelWrapper, nodeLabelText} = renderNodeLabelWithWrapper({paper: this.paper,x, y: y-70, text: label})
    const labelText = null

    const typeText = this.renderNodeTypeText(x, y-7, type, nodeTypeFontSize, nodeData);
    const shape = this.renderNodeShape(id, x, y, type, nodeData);
    const nodeIcon = this.renderNodeIcon(x, y, type, imgSrc, nodeData);

    const nodeWrapperRect = this.renderNodeWrapperRectangle({id, x, y, label, shapeElement: shape});

    const nodeIconGroup = this.paper.set();
    nodeIconGroup.push(nodeWrapperRect, shape, nodeIcon);

    const veritcalLineHeight = this.diagramManager?.paperHeight !== "100%" ? this.diagramManager?.paperHeight : this.defaultNodeVerticalLineHeight;
    const verticalLine = this.renderNodeVerticalLIne({x, y, veritcalLineHeight, nodeData});

    const vLineBbox = verticalLine.getBBox();
    const vLineBboxX  = vLineBbox.x;
    const vLineBboxY = vLineBbox.y;
    const vLineHeight = vLineBbox.height;
 
 
    const hoverMargin = 10; // buffer width on either side of the line
    const bufferRect = this.paper.rect(
      vLineBboxX - hoverMargin,
      vLineBboxY,
      2 * hoverMargin,
      vLineHeight
    ).attr({
      fill: "transparent",
      stroke: "none",
    });

    const initialPlusY = this.baseLineY + this.plusOffsetY;
    const plusCircle = this.createPlusCircle(x, initialPlusY);
    plusCircle.node.setAttribute("id", `node_${label}_add`);
    const plusBox = plusCircle.getBBox();

    this.attachHoverBehavior(plusCircle, id);


    group.push(nodeIcon, labelText, nodeLabelWrapper, nodeLabelText, typeText, shape, verticalLine, plusCircle, bufferRect);


    this.nodes[id] = { 
        id,
        name: label,
        group, 
        x, 
        y, 
        plusCircle,
        bufferRect,
        nodeWrapperRect, 
        nodeIconGroup, 
        verticalLine, 
        nodeIconShape: shape, 
        nodeIcon, 
        nodeLabelWrapper, 
        nodeLabelText,
        // nodeName: labelText, 
        nodeTypeLabel: typeText, 
        type,
        plusCircleGroup,
        highlightElement: shape
    };
    
  }

  renderNodeLabelText (){

  }

  renderNodeTypeText(x, y, type, fontSize, nodeData) {
    const nodeTypeText = this.paper.text(x, y - 10, getConstructLabel(type)).attr({
      'font-size': fontSize,
      'fill': Colors.dataflow.nodeType,
      'text-anchor': 'middle',
    });

    nodeTypeText.node.setAttribute("id", `node_${nodeData?.name}_type`);
    return nodeTypeText
  }

  renderNodeShape(id, x, y, type, nodeData) {

    const hexagonSize = 25;
    const diamondSize = 30;

    let nodeIconShape = null;
    if (type === 1) {
      nodeIconShape =  this.paper.path(this.getDiamondShapePath(x, y+20, diamondSize)).attr({
        fill: "#fff",
        stroke: "#ccc",
        "stroke-width": 0,
        cursor: "move",
        "z-index": 10
      });
    } else {
      const path = this.getHexagonPath(x, y + 20, hexagonSize);
      nodeIconShape = this.paper.path(path).attr({
        fill: "#fff",
        stroke: "#ccc",
        "stroke-width": 0,
      });
    }

    nodeIconShape.node.setAttribute("id", `node_${nodeData?.name}_shape`);



    nodeIconShape?.mouseover(() => {
      this.hidePopUpSet();  
    })

     

    return nodeIconShape;
  }

  renderNodeIcon(x, y, type, imgSrc, nodeData) {
    
    const centerY = y + 20;
    const iconSize = 28;

    const imageX = x - iconSize / 2;
    const imageY = centerY - iconSize / 2;

    const nodeIcon = this.paper.image(imgSrc, imageX, imageY, iconSize, iconSize);
    nodeIcon.attr({ }).data("name", "node_icon"); 

    nodeIcon.node.setAttribute("id", `node_${nodeData?.name}_icon`);

    return nodeIcon;
  }

  renderNodeVerticalLIne({x, y, veritcalLineHeight, nodeData}) {
    const verticalLine = this.paper.path(`M${x},${y + 45} L${x},${veritcalLineHeight}`).attr({
      stroke: Colors.black,
      "stroke-dasharray": "-",
      "stroke-width": 1
    });
    
    verticalLine.node.setAttribute("id", `node_${nodeData?.name}_path`);
    verticalLine.data("name", "vertical_line"); 


    return verticalLine;
  }


  
  handleHoverBetweenPaths(mouseY, allYs) {
    const proximity = 15;
    const bufferAfterLast = 50;
  
    if (!allYs || allYs.length === 0) return false; // No elements means don't allow
  
    // Sort Y positions just in case they're not already
    const sortedYs = [...allYs].sort((a, b) => a - b);
    const maxY = sortedYs[sortedYs.length - 1];
  
    // 1. Restrict ±15px around any existing element
    const isNearExistingY = sortedYs.some(yPos => {
      return Math.abs(mouseY - yPos) < proximity;
    });
    if (isNearExistingY) return false;
  
    // 2. If mouse is below the last element
    if (mouseY > maxY) {
      return false;
    }
  
    // 3. If mouseY is above first element or in between elements (not near any y)
    return true;
  }

  createPlusCircle(x, y, hoveredPath) {
    const plusCircle = this.paper.image(
      hoveredPath ? hoveredPath : this.icons.plusiconNormalPath,
      x - this.plusIconSize / 2,
      y,
      this.plusIconSize,
      this.plusIconSize
    );
    plusCircle.node.setAttribute("data-ui-tour-id", `create-element-icon`);
    return plusCircle;
  }

  attachHoverBehavior(plusCircle,  nodeId) {
    const hoverElements = [plusCircle];

    let isInside = false;
  
    const checkAndHide = () => {
      requestAnimationFrame(() => {
        if (!isInside) {
          plusCircle.attr("src", this.icons.plusiconNormalPath);
        }
      });
    };
  
    const onMouseEnter = (e) => {

      isInside = true;
      plusCircle.attr({ cursor: "pointer" });
      const plusX = plusCircle.attr("x");
      const plusY = plusCircle.attr("y");
  
      const nodeEntries = Object.entries(this.nodes).map(([id, node]) => ({ id, x: node.x }));
      nodeEntries.sort((a, b) => a.x - b.x);
      const currentNodeIndex = nodeEntries.findIndex(entry => entry.id === nodeId);
      const isLeftMost = currentNodeIndex === 0;
      const isRightMost = currentNodeIndex === nodeEntries.length - 1;

      if(isLeftMost){
        this.popUpVisibility.plus = true;
        this.popUpVisibility.right = true;
        this.popUpVisibility.bottom = true;
      } 
      else if(isRightMost){
        this.popUpVisibility.plus = true;
        this.popUpVisibility.left = true;
        this.popUpVisibility.bottom = true;
      }
      else{
        this.popUpVisibility.plus = true;
        this.popUpVisibility.left = true;
        this.popUpVisibility.right = true;
        this.popUpVisibility.bottom = true;
      }

      this.showPopUpIconsAt(plusX, plusY, nodeId)
    };
  
    const onMouseLeave = () => {
      isInside = false;
      checkAndHide();
    };
  
    hoverElements.forEach(el => {
      el?.mouseover(onMouseEnter);
      el?.mouseout(onMouseLeave);
    });
  }

  renderPopUpIcons(){
    const x  = 50;
    const y = 50;

    const plusButton = this.createPlusCircle(x, y - this.popupIconOffset/2, this.icons.plusiconHoveredPath);

    const bottomIcon = this.createPopupIcon(this.paper, x, y + this.popupIconOffset, this.icons.childTransactionIconPath, "bottom");
    const leftIcon = this.createPopupIcon(this.paper, x - this.popupIconOffset, y, this.icons.leftEventIconPath, "left");
    const rightIcon = this.createPopupIcon(this.paper, x + this.popupIconOffset, y, this.icons.rightEventIconPath , "right");
    this.popupSetItems  = this.paper.set().push(plusButton, bottomIcon, leftIcon, rightIcon);

    const bbox = this.popupSetItems.getBBox();
    const bufferPadding = 10;

    this.popupBufferRect = this.paper.rect(
      bbox.x - bufferPadding,
      bbox.y - bufferPadding,
      bbox.width + 2 * bufferPadding,
      bbox.height + 2 * bufferPadding
    ).attr({
      fill: "transparent",
      stroke: "none",
    });
  
    this.popupBufferRect.toBack();

    this.popupSetElements = {
      plus: plusButton,
      bottom: bottomIcon,
      left: leftIcon,
      right: rightIcon,
      buffer : this.popupBufferRect

    };
  
    // Step 3: Create final group including buffer rect
    this.globalPopUpSet = this.paper.set().push(
      this.popupBufferRect,
      plusButton,
      bottomIcon,
      leftIcon,
      rightIcon,
    );
  
    // Hover logic
    const onMouseEnter = (e) => {
      clearTimeout(this.popupHideTimeout);
      if(this.popUpVisibility.plus) this.popupSetElements.plus.show();
      if(this.popUpVisibility.right) this.popupSetElements.right.show();
      if(this.popUpVisibility.left) this.popupSetElements.left.show();
      if(this.popUpVisibility.bottom) this.popupSetElements.bottom.show();
    };
  
    const onMouseLeave = () => {
      this.popupHideTimeout = setTimeout(() => {
        this.hidePopUpSet();
      }, 100);
      // this.hidePopUpSet();

    };
  
    // Apply hover to all elements
    [this.popupBufferRect].forEach(el => {
      el.mouseover(onMouseEnter);
      el.mouseout(onMouseLeave);
    });

    this.globalPopUpSet.hide();

  }

  showPopUpIconsAt(popupX, popupY, nodeId, drawInBetween = false ) {

    const { plus, bottom, left, right } = this.popupSetElements;
    if (!plus) return;
    const plusXplusWidth = popupX;
  
    // Position each icon
    plus.attr({ x: popupX, y: popupY });
    bottom.attr({ x: popupX, y: popupY + this.popupIconOffset, title : "Create transaction"});
    left.attr({ x: popupX - this.popupIconOffset, y: popupY , title : "Create event"});
    right.attr({ x: popupX + this.popupIconOffset , y: popupY  , title : "Create event"});
  
    if(this.popUpVisibility.plus) plus.show();
    if(this.popUpVisibility.right) right.show();
    if(this.popUpVisibility.left) left.show();
    if(this.popUpVisibility.bottom) bottom.show();
    this.popupBufferRect.show();

    const _this = this;
    
 
    bottom.unclick().click(() => this.handlePopupIconClick("bottom", plusXplusWidth, popupY, nodeId, drawInBetween));
    left.unclick().click(() => this.handlePopupIconClick("left", plusXplusWidth, popupY, nodeId, drawInBetween));
    right.unclick().click(() => this.handlePopupIconClick("right", plusXplusWidth, popupY, nodeId, drawInBetween));
  
    const visibleIcons = [plus, bottom, left, right].filter(el => el.attrs.display !== "none");
    const tempSet = this.paper.set().push(...visibleIcons);
    const bbox = tempSet.getBBox();
  
    const bufferPadding = 10;
    this.popupBufferRect.attr({
      x: bbox.x - bufferPadding,
      y: bbox.y - bufferPadding,
      width: bbox.width + 2 * bufferPadding,
      height: bbox.height + 2 * bufferPadding
    });

    const onMouseEnter = () => {      
    };
  
    const onMouseLeave = () => {
    };

    right.mouseover(onMouseEnter);
    right.mouseout(onMouseLeave);

    const onBottomMouseMove = (e) => {    
      if(e != null && e != undefined){
        _this.hideCreateIcons(e)
      }
    };

    bottom.mousemove(onBottomMouseMove);

    
  
  }

  hidePopUpSet(){
    this.globalPopUpSet.hide();
    this.popUpVisibility.plus = false;
    this.popUpVisibility.right = false;
    this.popUpVisibility.left = false;
    this.popUpVisibility.bottom = false;
  }

  addEventData(eventData, parentId, order){
 
    let updatedEvents = [...this.events, eventData ];
    let updatedSelectedTransaction =   this.selectedTransaction;
    let allTransactions = this.transactions;
 
    if(parentId === this.selectedTransaction._id){
      let selectedTx = this.selectedTransaction;
      selectedTx.events = [...selectedTx.events, {id:eventData._id, order}]
      updatedSelectedTransaction = selectedTx;
    }
 
    allTransactions.map(tx => {
      if(tx._id === parentId){
        tx.events = [...tx.events, {id:eventData._id, order}]
      }
    })
 
    return {updatedEvents,updatedSelectedTransaction,  allTransactions}
   
  }
 
  addTransactionData(trData, parentId, order){

    let updatedTransactions = [...this.transactions, trData ];
    let updatedSelectedTransaction =   this.selectedTransaction;
 
    if(parentId === this.selectedTransaction._id){
      let selectedTx = this.selectedTransaction;
      selectedTx.nestedTransactions = [...selectedTx.nestedTransactions, {id:trData._id, order}]
      updatedSelectedTransaction = selectedTx;
    }
 
    updatedTransactions?.map(tx => {
      if(tx?._id === parentId){
        tx.nestedTransactions = [...tx.nestedTransactions, {id:trData._id, order}]
      }
      return tx;
    })
 
    return {updatedTransactions,updatedSelectedTransaction}
   
  }
 
  generateEventData(elementId, sourceId, dst, eventName){
 
    return {
      _id : elementId,
      name: eventName,
      desc: "",
      blueprint_id : this.selectedTransaction.blueprint_id,
      message: "",
      isError:false,
      attributes: { onsend : false, onrecv : false },
      src: sourceId,
      dst: dst,
      type: 8,
      validation: "",
      timeout: "",
      key: "",
      context: ""
    }
 
  }
 
  generateTransactionData (elementId,nestedTransactionName){
    return {
      _id: elementId,
      name: nestedTransactionName,
      description: "",
      blueprint_id : this.selectedTransaction.blueprint_id,
      type: constructIds[7].id,
      clusterlets: [],
      timeout: "",
      events: [],
      nestedTransactions : [],
      invokedTransactions : []
    }
  }

  isControllerNode(nodeId) {
    const nodeDetail = this.clusterlets.find(
      cl => cl?._id?.toString() === nodeId?.toString()
    );
  
    return nodeDetail?.type === 1 && nodeDetail?.subType &&  nodeDetail?.subType === "controller";
  }


  handlePopupIconClick(direction, popUpX, popUpY, sourceId, drawInBetween = false, parentId){
    try {
      
    
    this.arrowManager.lastExpandedChild = null; //To disable animation while rerendering
    this.hidePopUpSet();

    let nearestYElement = popUpY;   

    if(drawInBetween){
      let matchedRects = [];
      nearestYElement = (this.getNearestGreaterYElement(popUpY) != null && this.getNearestGreaterYElement(popUpY).y )? this.getNearestGreaterYElement(popUpY).y  : popUpY;
      Object.entries(this.arrowManager.transactionBackgrounds).map(([id, data]) => {
        const bgBbox = data.getBBox();
        if (popUpY > bgBbox.y && popUpY + this.popupIconOffset / 2 < (bgBbox.y + bgBbox.height)) {
          matchedRects.push({ id, height: bgBbox.height });
        }
      }); 
      
      if (matchedRects.length > 0) {
        matchedRects.sort((a, b) => a.height - b.height);
        parentId = matchedRects[0].id;
      }

    }

    let parentTransactionData  = (parentId == null || parentId === undefined) ?  this.selectedTransaction : this.transactions.find(tx => tx._id === parentId)


    let pTxData = {...parentTransactionData}

    const order = this.getNewOrderAtY(popUpY, pTxData);

    let elementId = generateMongoId();    

    if(direction === "right" ) popUpX += this.popupIconOffset / 2;
    if(direction === "left") popUpX -= this.popupIconOffset / 2;

    if (direction === "right" || direction === "left") {
      const isSourceController = this.isControllerNode(sourceId);
      const nearest = this.findNearestNode(popUpX, direction, sourceId, this.connections, isSourceController);


      if (nearest ) {
        const eventName = generateName(this.arrowManager.drawnEvents, "event") || "Event_1";
        let generatedEventData = this.generateEventData(elementId, sourceId, nearest.nodeId, eventName)
        let updatedConstructs = this.addEventData(generatedEventData, parentId !== undefined ? parentId : this.selectedTransaction._id, order)

        // this.arrowManager.renderEvent({eventId : elementId, fromId: sourceId, toId: nearest.nodeId, label: eventName, newEvent:true, drawInBetween, yPosition : nearestYElement});
        this.lastDrawnElement = { type : "event", id: elementId, src: sourceId, dst: nearest.nodeId, order, parentId };
        this.diagramManager.focusElement = {type : "event", id: elementId, y : popUpY}
        // this.triggerCreateEventAPI(elementId, sourceId, nearest.nodeId, eventName, order, parentId)
        this.diagramManager.updateTransactionData({selectedTransaction: updatedConstructs.updatedSelectedTransaction, clusterlets : this.clusterlets, events : updatedConstructs.updatedEvents, transactionEvents:this.transactionEvents,  transactions: updatedConstructs.allTransactions, connections: this.connections})
        this.diagramManager.clearAllElements();
        this.diagramManager.init();
      }else{
        this.dispatch(handleSnackBar({ open: true, message: 'No connection exists to the target', severity: 'error' }));
      }

    }else if (direction === "bottom") {
      const {min,max} = this.getMinMaxByOrder(this.selectedTransaction.clusterlets)
      if(min != null &&  max != null) {
        const nestedTransactionName = generateName(this.arrowManager.drawnChildTransactions, "transaction") || "CT1";
        // this.arrowManager.renderTransaction({fromId : min, toId: max, label: nestedTransactionName, transactionId : elementId, drawInBetween, yPosition : nearestYElement});
        let generatedNestedTransaction  = this.generateTransactionData(elementId,nestedTransactionName);
        let updatedConstructs = this.addTransactionData(generatedNestedTransaction, parentId != undefined ? parentId : this.selectedTransaction._id, order);
        this.lastDrawnElement = { type : "transaction", id: elementId, order, parentId };
        this.diagramManager.focusElement = {type : "transaction", id: elementId, y : popUpY }
        this.arrowManager.expandedChildTransactions[elementId] = true;
        // this.triggerCreateTransactionAPI(elementId,nestedTransactionName, order, parentId);
        this.diagramManager.updateTransactionData({selectedTransaction: updatedConstructs.updatedSelectedTransaction, clusterlets : this.clusterlets, events : this.events, transactionEvents:this.transactionEvents,  transactions: updatedConstructs.updatedTransactions, connections: this.connections});
        this.diagramManager.clearAllElements(); 
        this.diagramManager.init();
      }
    }


    } catch (error) {
      console.error(`Handling popup icon click failed. `, error);
      this.diagramManager.clearAllElements(); 
      this.diagramManager.init();
    }
  }

  

  onHoverVerticalLine(){
    Object.keys(this.nodes)?.forEach(item => {
      this.attachHoverForVerticalLine(item)
    })      

    // To hide the popup icons when hovering on child txn rectangles
    Object.values(this.arrowManager?.childTransactions)?.forEach(child => {
      if(child?.childWrapperRectangle){
        child?.childWrapperRectangle?.mouseover(() => {
          this.hidePopUpSet();
        })
      }
    })
  }

  hideCreateIcons = (e) => {

    const handlerYs = [];
    const range = 15; 

    Object.values(this.arrowManager.eventArrows).forEach((data, value) => {

      if(data?.onrecvHandlerBox !== undefined && data?.onrecvHandlerBox !== null){
        const recvHandlerBbox = data?.onrecvHandlerBox.getBBox();
        handlerYs.push(recvHandlerBbox.y); 
      }
      else if(data?.onsendHandlerBox !==  undefined && data?.onsendHandlerBox){
        const onsendHandlerBbox = data?.onsendHandlerBox.getBBox();
        handlerYs.push(onsendHandlerBbox.y);         
      }
    })


    const canvasY = e.clientY - this.paper.canvas.getBoundingClientRect().top;


    handlerYs.forEach(pos => {
      if (canvasY >= pos && canvasY <= pos + range) {
        // Execute your function
        this.hidePopUpSet(); 
      }
    });


  }

  attachHoverForVerticalLine = (elId) => {
    let verticalLine = this.nodes[elId] ? this.nodes[elId].verticalLine : null;
    if (verticalLine == null) return;

  
    const buffRect = this.nodes[elId] ? this.nodes[elId].bufferRect : null;
    if (buffRect == null) return;
 
    const hoverElements = this.paper.set();
    hoverElements.push(verticalLine, buffRect);
  
    const lineBbox = verticalLine.getBBox();
    const x = lineBbox.x;
    const y = lineBbox.y;

    // Add invisible buffer around the line for easier hover detection
    const hoverMargin = 10; // buffer width on either side of the line       
    const allYs = [
      ...Object.values(this.arrowManager.eventArrows).map(e => e.y),
      ...Object.values(this.arrowManager.childTransactions).map(c => c.y),
      ...Object.values(this.arrowManager.invokedTransactions).map(c => c.y),
    ].sort((a, b) => a - b);

    if(this.nodes[elId] && this.nodes[elId].plusCircle != undefined){
      let plusCircleBbox = this.nodes[elId].plusCircle.getBBox();
      if(plusCircleBbox.y) allYs.push(plusCircleBbox.y);
    }

   
    hoverElements.mouseover((e) => {
      const canvasY = e.clientY - this.paper.canvas.getBoundingClientRect().top;
      const withinValidGap = this.handleHoverBetweenPaths(canvasY, allYs);
      const nodeEntries = Object.entries(this.nodes).map(([id, node]) => ({ id, x: node.x }));
      nodeEntries.sort((a, b) => a.x - b.x);
      const currentNodeIndex = nodeEntries.findIndex(entry => entry.id === elId);
      const isLeftMost = currentNodeIndex === 0;
      const isRightMost = currentNodeIndex === nodeEntries.length - 1;

      if(isLeftMost){
        this.popUpVisibility.left = false;
        this.popUpVisibility.plus = true;
        this.popUpVisibility.right = true;
        this.popUpVisibility.bottom = true;

      } 
      else if(isRightMost){
        this.popUpVisibility.right = false;
        this.popUpVisibility.plus = true;
        this.popUpVisibility.left = true;
        this.popUpVisibility.bottom = true;
      }
      else{
        this.popUpVisibility.plus = true;
        this.popUpVisibility.left = true;
        this.popUpVisibility.right = true;
        this.popUpVisibility.bottom = true;
      }

      if(withinValidGap){
        if(this.nodes[elId] && this.nodes[elId].bufferRect !== undefined) this.nodes[elId].bufferRect.attr({cursor:"pointer"})
        this.showPopUpIconsAt(x-hoverMargin, canvasY - this.popupIconOffset/2 , elId, true, e);
      }else{
        this.hidePopUpSet();
      }
     
    });


    hoverElements.mousemove((e) => {
      const canvasY = e.clientY - this.paper.canvas.getBoundingClientRect().top;
      const withinValidGap = this.handleHoverBetweenPaths(canvasY, allYs);
      const nodeEntries = Object.entries(this.nodes).map(([id, node]) => ({ id, x: node.x }));
      nodeEntries.sort((a, b) => a.x - b.x);
      const currentNodeIndex = nodeEntries.findIndex(entry => entry.id === elId);
      const isLeftMost = currentNodeIndex === 0;
      const isRightMost = currentNodeIndex === nodeEntries.length - 1;

      if(isLeftMost){
        this.popUpVisibility.left = false;
        this.popUpVisibility.plus = true;
        this.popUpVisibility.right = true;
        this.popUpVisibility.bottom = true;

      } 
      else if(isRightMost){
        this.popUpVisibility.right = false;
        this.popUpVisibility.plus = true;
        this.popUpVisibility.left = true;
        this.popUpVisibility.bottom = true;
      }
      else{
        this.popUpVisibility.plus = true;
        this.popUpVisibility.left = true;
        this.popUpVisibility.right = true;
        this.popUpVisibility.bottom = true;
      }

      if(withinValidGap){
        if(this.nodes[elId] && this.nodes[elId].bufferRect !== undefined) this.nodes[elId].bufferRect.attr({cursor:"pointer"})
        this.showPopUpIconsAt(x-hoverMargin, canvasY - this.popupIconOffset/2 , elId, true, e);
      }else{
        this.hidePopUpSet();
      }
     
    });
  
    hoverElements.mouseout(() => {
      setTimeout(() => {
      }, 150);
    });
  };
  

  

  renderNodeWrapperRectangle({id, x, y, label, shapeElement}){
    const boxWidth = this.nodeWrapperRectConfig.width;
    const boxHeight = this.nodeWrapperRectConfig.height;


    const wrapperRectangle = this.paper.rect(
      x- boxWidth/2,
      y-2,
      boxWidth,
      boxHeight
    ).attr({
      fill: 'transparent',
      stroke: 'grey',
      "stroke-width": 0,
      cursor: 'move',
      rx: 5,
      ry: 5,
      title: label
    });
    wrapperRectangle.toFront();

    wrapperRectangle.node.setAttribute("id", `node_${label}_wrapperRectangle`);
    wrapperRectangle.node.setAttribute("data-ui-tour-id", `node`);

    // Hightlight while mouse over
    wrapperRectangle.mouseover(() => {
      this.hidePopUpSet();
      this.diagramManager?.hightlightHoverItem({id, type: "clusterlet"});
    })
    wrapperRectangle.mouseout(() => {
      this.diagramManager?.removeHoveringHighlight();
    })


    return wrapperRectangle;
  }

  renderNodeDragHandler(x, y){
    const nodeWrapperRectWidth = this.nodeWrapperRectConfig.width;
    const {width, height} = this.dragHandlerConfig;

    // Draw the drag handler icon (hidden by default)
    const dragHandler = this.paper.image(
      this.icons.dragHandle,
      x + (nodeWrapperRectWidth/2),
      y,
      width,
      height
    ).attr({ cursor: "move", title: 'Click and drag to change position of clusterlet'});
    
    dragHandler.toFront();
    dragHandler.hide();

    return dragHandler;
  }
  
  updatePlusIcons(amount=null) {
    let newY = this.baseLineY + this.plusOffsetY + this.level * this.plusShiftStep;
    if(amount){
      newY = this.baseLineY + this.plusOffsetY + this.level * amount;
    }
    Object.values(this.nodes).forEach(node => {
      node?.plusCircle.attr({ y: newY });
    });
  }

  getNearestGreaterYElement(y, eventId) {
    let closest = null;
    let minDelta = Infinity;
  
    Object.entries(this.arrowManager.transactionElemnts).forEach(([key, value]) => {
      if (!value.group || typeof value.group.getBBox !== 'function') return;
  
      const groupY = value.y;
      const delta = groupY - y;
  
      if (delta > 0 && delta < minDelta) {
        minDelta = delta;
        closest = { id: key, y: groupY };
      }
    });
  
    return closest; 
  }

  allElementsBelowYPosition(yPosition, eventId){
    let result = [];

    Object.entries(this.arrowManager.transactionElemnts).forEach(([id, value]) => {

      if (!value.group || typeof value.group.getBBox !== 'function') return;

      if(value.id != eventId){
        const groupBBox = value.group.getBBox();
        if (groupBBox.y > yPosition) {
          result.push({
            id: id,
            data: value,
            topY: groupBBox.y
          });
        }
        
      }
    })
    return result;

  }

  shiftElements(elementsToShift, y){
    elementsToShift.forEach(item => {
      this.arrowManager.updateGroupYPositionWithDelta(item.data, this.arrowManager.verticalDragSpacing, 24)
    })
  }

  incrementLevelAndUpdatePlusIcons() {
    this.level++;
    this.updatePlusIcons();
  }

  /**
   * Retrieve a node by its ID
   */
  getNode(id) {
    return this.nodes[id];
  }

  /**
   * Retrieve all nodes
   */
  getAllNodes() {
    return this.nodes;
  }

  getHexagonPath(cx, cy, size) {
    const angle = Math.PI / 3; // 60 degrees
    const path = [];
    for (let i = 0; i < 6; i++) {
      const theta = angle * i;
      const x = cx + size * Math.cos(theta);
      const y = cy + size * Math.sin(theta);
      path.push(i === 0 ? "M" : "L", x, y);
    }
    path.push("Z");
    return path.join(" ");
  }

  getDiamondShapePath(cx, cy, size) {
    const verticalSpan = size * Math.sin(Math.PI / 3); // Same as hexagon vertical reach
    const path = [];
    path.push("M", cx, cy - verticalSpan);           // Top
    path.push("L", cx + size, cy);                   // Right
    path.push("L", cx, cy + verticalSpan);           // Bottom
    path.push("L", cx - size, cy);                   // Left
    path.push("Z");

    return path.join(" ");
  }

  /**
   * Clear all drawn nodes
   */
  updatePopupYPositions = (popupSet, newY, isLeftMost, isRightMost, hoverBuffer, newX) => {
    popupSet.forEach(el => { 
      let yPosition = el?.data("position") === "bottom" ? newY + 28  : newY;
      el?.attr({ y: yPosition - 30 / 2 });
      if((isLeftMost && el?.data("position") === "left") || (isRightMost && el?.data("position") === "right" )) {
        el?.hide();
      }
      else{
        el?.show();
      }
  
    });

    if(hoverBuffer){
      const bBox = popupSet.getBBox();
      hoverBuffer.attr({y: newY, x: bBox.x})
    }
  };

  createPopupIcon(paper, x, y, imagePath, position, id, size, onClick) {

    const icon = paper.image(imagePath, x - this.popupIconSize / 2, y - this.popupIconSize / 2, this.popupIconSize, this.popupIconSize)
    icon.attr({ cursor: "pointer" });
    icon.data("position", position);
    icon.data("id", id);
    if (onClick) icon.click(onClick);

    icon.node.setAttribute("id", `create_icon_${position}`);

    return icon;
  }

  findNearestNode(sourceX, direction = "right", excludeNodeId = null, connections, isSourceController) {
    let nearestNode = null;
    let minDistance = Infinity;
    let self = this;
      
    for (const [nodeId, nodeData] of Object.entries(this.nodes)) {
      if (nodeId === excludeNodeId) continue; // don't connect to self

      const checkConnection = doesConnectionExist({ connections, sourceId: excludeNodeId, targetId: nodeId, clusterlets: self.clusterlets })
      if ( !checkConnection) continue;


      const nodeX = nodeData.x;
  
      const isRight = nodeX > sourceX;
      const isLeft = nodeX < sourceX;
  
      if ((direction === "right" && isRight) || (direction === "left" && isLeft)) {
        const distance = Math.abs(nodeX - sourceX);
        if (distance < minDistance) {
          minDistance = distance;
          nearestNode = { nodeId, x: nodeX };
        }
      }
    }
  
    return nearestNode;
  }


  saveUpdatedClusterletOrderToDB(clusterletOrder){
    this.diagramManager.preventCompleteRerender = true;

    this.dispatch(invokePostService('updateClusterletOrder', { clusterletArray: clusterletOrder }, [this.selectedTransaction._id]))
      .then(savedData => {
        if (savedData.status) {
          this.dispatch(setReRender());
          this.dispatch(handleSnackBar({ open: true, message: 'Clusterlet reordered', severity: 'success' }));
        } else {
          // this.diagramManager.preventCompleteRerender = false;
          this.dispatch(setReRender());
          this.dispatch(handleSnackBar({ open: true, message: 'Clusterlet reorder failed', severity: 'error' }));
        }
      }).catch(error => {
        console.error(error)
      });

  }

  

  resetAllNodePositionsOnStopDragging(){
    this.arrowManager.lastExpandedChild = null;
    this.diagramManager?.clearAllElements();
    this.diagramManager?.init();
  }


  updateNodeShapeXPosition({pathElement, newX, color="#ccc", type, y}) {
    const defaultColor = "#ccc"
    const diamondSize = 30;
    const hexagonSize = 25;

    let updatedPath = ``;
    if(type === 1){
      updatedPath = this.getDiamondShapePath(newX, y+20, diamondSize)
    }else{
      updatedPath = this.getHexagonPath(newX, y + 20, hexagonSize)
    }
    pathElement.attr({ 
      path: updatedPath,
      stroke: color,
      "stroke-width": color === defaultColor ? 0 : 1,
    });
    return pathElement;
  }


  updateNodeHorizontalPositioning({node, newX, status="drop"}){
    if(newX === null) return;

    // updated node wrapper (rect)
    let bbox = node?.nodeWrapperRect?.getBBox();
    let bboxWidth = bbox.width;
    node?.nodeWrapperRect.attr({ x: newX - bboxWidth/2 });

    // update vertical line (path)
    const lineColor = status === "drag" ? "#842eb3" : Colors.black;
    updateNodeVerticalLineXPosition({lineElement: node?.verticalLine, newX: newX, color: lineColor});


    // update node icon shape (path)
    const shapeColor = status === "drag" ? "#842eb3" : "#ccc";
    this.updateNodeShapeXPosition({pathElement: node?.nodeIconShape, newX: newX, y: node?.y, type: node?.type, color: shapeColor});

    // update node icon (image)
    bbox = node?.nodeIcon?.getBBox();
    bboxWidth = bbox.width;
    node?.nodeIcon?.attr({ x: newX-bboxWidth/2 });

    // update node name
    node?.nodeName?.attr({ x: newX });


    updateNodeLabelXPosition({
      nodeLabelWrapper: node?.nodeLabelWrapper,
      nodeLabelText: node?.nodeLabelText,
      newX
    });

    // update node type label
    node?.nodeTypeLabel?.attr({ x: newX });
  }

  handleNodeDroppingInNewPosition({newNodePositions}){

    // updating nodes
    const clusterletOrder = generateClusterletsWithUpdatedOrder({newNodePositions, nodes: this.nodes} );

    this.selectedTransaction = {...this.selectedTransaction, clusterlets: clusterletOrder}

    // Update the paper with new order
    const updatedTransactions = this.transactions?.map(item => {
      if(item?._id === this.selectedTransaction?._id){
        item.clusterlets = clusterletOrder;
      }

      return item;
    })

    this.arrowManager.lastExpandedChild = null;
    this.diagramManager?.updateTransactionData({
      selectedTransaction: {...this.selectedTransaction, clusterlets: clusterletOrder}, 
      transactions: updatedTransactions, 
    })
    this.diagramManager?.clearAllElements();
    this.diagramManager?.init();


    this.saveUpdatedClusterletOrderToDB(clusterletOrder);
  }

  dragClusterletToReorder(){
    const _this = this;
    Object.keys(this.nodes)?.forEach(id => {
        const node = this.nodes[id];
        const itemType = node?.type === 1 ? "external_function" : node?.type === 2 ? "clusterlet" : "analytics"
        let wasDragged = false;

        let startX = node.x; // Initial position

        const { handleDragMove, resetScroll, getScrollDelta } = enableHorizontalAutoScrollOnDrag();
        

        node?.nodeWrapperRect?.drag( 
          // drag move
          function onDragMove(dx, dy, x, y, event) {
            
            let handlerCodeEditStatus = _this.checkCodeEditorStatus() !== undefined ? _this.checkCodeEditorStatus() : true ;
            if(handlerCodeEditStatus === true){
              return;
            }

            wasDragged = true;
            _this.hidePopupIconset();
            hideAllOtherElementsOnNodeDragging({allNodes: _this.nodes, allEvents: _this.arrowManager?.eventArrows, allChildTxns: _this.arrowManager?.childTransactions , allInvokedTxns: _this.arrowManager?.invokedTransactions});
            
            handleDragMove(event);
            
            let newX = startX + dx
            newX = newX + getScrollDelta();
          
            _this.updateNodeHorizontalPositioning({node, newX: newX, status: "drag"});
  
            const newXForNearbyNode = _this.newNodePositions && _this.newNodePositions[id] !== undefined ? _this.newNodePositions[id] : startX;;
            const nearby = getNearbyNodeOnDrag({draggingNode:node, allNodes: _this.nodes, newNodePositions: _this.newNodePositions});
            if(nearby){
              // Update the x position of near by node
              _this.updateNodeHorizontalPositioning({node: nearby, newX: newXForNearbyNode, status: "swap"});
             
              _this.newNodePositions[nearby.id] = newXForNearbyNode;
              _this.newNodePositions[node.id] = nearby?.x;
              node.x = nearby?.x
            }
          },

          // drag start
          function onDragStart() {
            _this.newNodePositions = {};
            wasDragged = false;
            startX = node?.x ;
          },

          // drag end
          function onDragEnd() {
            if (!wasDragged) {
              // Simulate click behavior here
              _this.diagramManager?.hightLighSelectedElementInDiagram({id: node?.id, type: itemType});
              _this.handleSelectedItem({ id, type: itemType, name: node?.name, labelElement: node?.nodeIconShape });
              return; // no need to proceed further
            }else{
              resetScroll();

              setTimeout(() => {
                wasDragged = false;
              }, 150); // 100–150ms is usually enough

              if(_this.newNodePositions && _this.newNodePositions[id]){
                  _this.handleNodeDroppingInNewPosition({newNodePositions: _this.newNodePositions});
              }else{
                _this.resetAllNodePositionsOnStopDragging();
              }

            }
          }
        );
        
        
        
        
    })
  }

  getMinMaxByOrder(arr) {
    if (!Array.isArray(arr) || arr.length === 0) {
      return { min: null, max: null };
    }
  
    const sorted = [...arr].sort((a, b) => a.order - b.order);
    return {
      min: sorted[0].id,
      max: sorted[sorted.length - 1].id,
    };
  }

  triggerCreateEventAPI(eventId, src, dst, name, order, parentId){

    let event = {
      _id : eventId,
      name: name,
      desc: name,
      message: "",
      isError:false,
      attributes: { onsend : false, onrecv : false },
      src,
      dst,
      type: 8,
      validation: "",
      timeout: "",
      key: "",
      context: ""
    }

    this.dispatch(invokePostService('createEvent', { event, transactionId: (parentId !== undefined && parentId !== null) ? parentId : this.selectedTransaction._id, order, messageData: null }, []))
      .then((savedData) => {
        if (savedData.status) {
          this.diagramManager.preventCompleteRerender = true;
          this.diagramManager.preventConstructsUpdate = true;
        } else {        
          if(Array.isArray(savedData?.errors) && savedData.errors[0] !== undefined && savedData.errors[0].message !== undefined){
            this.dispatch(handleSnackBar({ open: true, message: savedData.errors[0].message, severity: 'error' }));
          }   
        }
        this.dispatch(setReRender());

      })
      .catch(error => {
        this.dispatch(setReRender());
        console.error("Event creation failed. ", error);
        this.dispatch(handleSnackBar({ open: true, message: "Create event failed", severity: 'error' }));
      });

  }

  triggerCreateTransactionAPI(nestedTransactionId, name, order, parentId){

    const nestedTransaction = {
      _id: nestedTransactionId,
      name: name,
      description: name,
      type: constructIds[7].id,
      clusterlets: [],
      timeout: "",
      events: []
    }

    let parentTx = parentId ? parentId: this.selectedTransaction._id

    this.dispatch(invokePostService('createNestedTransaction', { nestedTransaction, order }, [parentTx]))
      .then(savedData => {
        if (savedData.status) {
          this.diagramManager.preventCompleteRerender = true;
          this.diagramManager.preventConstructsUpdate = true;  
        } else {
          if(Array.isArray(savedData?.errors) && savedData.errors[0] !== undefined && savedData.errors[0].message !== undefined){
            this.dispatch(handleSnackBar({ open: true, message: savedData.errors[0].message, severity: 'error' }));
          } 
        }
        this.dispatch(setReRender());
      })
      .catch(error => console.error(error));


  }

  getNewOrderAtYOld(mouseY) {
    const {drawnEvents, drawnChildTransactions} =  this.arrowManager.getDrawnItems();

    const items = [
      ...drawnEvents.map((e) => ({ id: e.id, y: e.yPosition })),
      ...drawnChildTransactions.map((t) => ({ id: t.id, y: t.yPosition })),
    ];
  
    if (items.length === 0) return 500;
  
    const sorted = items.sort((a, b) => a.y - b.y);
  
    const before = [...sorted].reverse().find((i) => i.y < mouseY);
    const after = sorted.find((i) => i.y >= mouseY);
  
    const getOrder = (id) => this.findOrderFromId(id) ?? 500;
  
    if (!before && after) return getOrder(after.id) - 100;
    if (before && !after) return getOrder(before.id) + 100;
    if (!before && !after) return 500;
  
    return (getOrder(before.id) + getOrder(after.id)) / 2;
  }

  getNewOrderAtY(mouseY, parentTransaction) {

    let pTxElements = [];

    if( parentTransaction !== undefined && parentTransaction != null){

      if(parentTransaction.events) pTxElements = [...pTxElements, ...parentTransaction.events];
      if(parentTransaction.nestedTransactions) pTxElements = [...pTxElements, ...parentTransaction.nestedTransactions];
      if(parentTransaction.invokedTransactions) pTxElements = [...pTxElements, ...parentTransaction.invokedTransactions];

    }

    const childTxDrawnElemnts = [];

    Object.entries(this.arrowManager.eventArrows).forEach(([id, ev])=>{
     if(pTxElements.find(el => el.id === ev.id)) childTxDrawnElemnts.push({id, y : ev.y})
    })

    Object.entries(this.arrowManager.childTransactions).forEach(([id, tr])=>{
      if(pTxElements.find(el => el.id === tr.id)) childTxDrawnElemnts.push({id, y : tr.y})
    })

    Object.entries(this.arrowManager.invokedTransactions).forEach(([id, tr])=>{
      if(pTxElements.find(el => el.uuid === tr.id)) childTxDrawnElemnts.push({id, y : tr.y})
    })

    const sortedOnY = childTxDrawnElemnts.sort((a, b) => a.y - b.y);

    const before = [...sortedOnY].reverse().find((i) => i.y < mouseY);
    const after = sortedOnY.find((i) => i.y >= mouseY);

    const getOrder = (id) => pTxElements.find(tx => tx.id === id) ? pTxElements.find(tx => tx.id === id).order : pTxElements.find(tx => tx.uuid === id) ? pTxElements.find(tx => tx.uuid === id).order : null ;

    if (before == null && after == null) return 500;
    if (before == null && after != null) return getOrder(after.id) - 100;
    if (before != null && after == null) return getOrder(before.id) + 100;

    return (getOrder(before.id) + getOrder(after.id)) / 2;
    
  }

  findOrderFromId(id){

    let transactionEvents = [];
    let transactionChildren = [];
    let transactionInvoked = [];

    this.transactions.forEach(tr => {
      if(tr.events.length > 0) transactionEvents = [...transactionEvents, ...tr.events];
      if(tr.nestedTransactions.length > 0) transactionEvents = [...transactionEvents, ...tr.nestedTransactions];
      if(tr.invokedTransactions.length > 0) transactionEvents = [...transactionEvents, ...tr.invokedTransactions];

    })

    const allItems = [...transactionEvents, ...transactionChildren, ...transactionInvoked, ...this.newDrawnElements]

    let el = allItems.find((item) => item?.id === id);
    if (el !== undefined && el != null) return el.order;
 
  }

  getClusterletIconPath(item, { fileUrl = '', iconPath = 'node_icons', defaultIcon = 'clusterlet' } = {}) {
    if (!item) return '';

    let imgSrc = '';

    if (item.iconSource === 'library') {
        imgSrc = `/cached_icons/${item.icon}`;
    } else if (item.iconSource === 'custom' || item.isCustomIcon) {
        imgSrc = `${fileUrl}${item.icon}`;
    } else if (!item.icon && defaultIcon !== undefined) {
        imgSrc = `/${iconPath}/${defaultIcon}.svg`;
    } else {
        imgSrc = `/${iconPath}/${item.icon}.svg`;
    }

    return imgSrc;
  }
  
  hidePopupIconset(){
    if(this.globalPopUpSet) this.globalPopUpSet?.hide();
  }


}

